import { render, staticRenderFns } from "./accident.vue?vue&type=template&id=76bce3ce"
import script from "./accident.vue?vue&type=script&lang=js"
export * from "./accident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports